var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-timeline"},[_c('ul',_vm._l((_vm.items),function(item,key){return _c('li',{key:key,class:[
          'filled', 
          'connection',
          key === 0 ? 'first' : '',
          key === _vm.items.length - 1 ? 'last' : ''
      ]},[_c('div',{staticClass:"bullet"},[_c('svg',{staticClass:"has-form",attrs:{"aria-hidden":"true","viewBox":"0 0 32 32","focusable":"false"}},[_c('circle',{attrs:{"stroke":"none","cx":"16","cy":"16","r":"10"}})])]),_vm._v(" "),_c('div',[_vm._t("row",null,{"item":item,"key_":key})],2)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }